import { render, staticRenderFns } from "./OaRoutePreview.vue?vue&type=template&id=55d9d8a3&scoped=true"
import script from "./OaRoutePreview.vue?vue&type=script&lang=js"
export * from "./OaRoutePreview.vue?vue&type=script&lang=js"
import style0 from "./OaRoutePreview.vue?vue&type=style&index=0&id=55d9d8a3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d9d8a3",
  null
  
)

export default component.exports